import { Component, Inject, OnDestroy, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Alert, Thing } from "../../model";
import { ThingContextService } from "../../service/thing-context.service";
import { EditTagDialogComponent } from "../../shared/component/tag-editor/edit-tag-dialog.component";
import { getContextServiceProvider } from "../../shared/provider/context-service.provider";
import { getExportContextServiceProvider } from "../../shared/provider/export-context-service.provider";
import { getThingContextServiceProvider } from "../../shared/provider/thing-context-service.provider";

@Component({
    selector: 'event-selection-input-dialog',
    template: require('./event-selection-input-dialog.component.html'),
    styles: [require('./event-selection-input-dialog.component.css')],
    providers: [getContextServiceProvider(null, false), getThingContextServiceProvider(null, false), getExportContextServiceProvider(false)]
})
export class EventSelectionInputDialogComponent implements OnDestroy {

    private originalContextThing: Thing;

    query: { property: string, predicate: string, value: any }[];

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) private dialogRef: MatDialogRef<EditTagDialogComponent>,
        @Inject(forwardRef(() => ThingContextService)) private thingContextService: ThingContextService,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.originalContextThing = thingContextService.getCurrentThing();
        if (data.thing) {
            thingContextService.updateCurrentThing(data.thing);
        }
        if (data.eventSeverities) {
            this.query = [{ property: 'eventSeverity', predicate: null, value: data.eventSeverities }];
        }
    }

    ngOnDestroy(): void {
        this.resetContext();
    }

    close(): void {
        this.dialogRef.close();
    }

    eventSelected(data: { event: Alert, isHistorical: boolean }): void {
        this.dialogRef.close(data);
    }

    private resetContext(): void {
        this.thingContextService.updateCurrentThing(this.originalContextThing);
    }

}